<template>
    <div class="login">
        <el-dialog title="" style="display: none;" :visible.sync="visible" width="440px" :before-close="closeSerDialog" lock-scroll
                   center class="vm-serve-dialog" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-tabs v-model="active.name" v-if="active.type=='login'" @tab-click="handleLoginTab">
                <el-tab-pane label="账号登录" name="first">
                    <el-form :model="loginPass" :rules="rules" ref="loginPass" label-width="0" class="demo-ruleForm">
                        <el-form-item label="" prop="username">
                            <el-input v-model.trim="loginPass.username" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号"
                                      clearable @input="getLocalPsw"></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="password">
                            <el-input type="password" v-model.trim="loginPass.password" prefix-icon="el-icon-lock"
                                      placeholder="请输入密码" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" class="vm-btns">
                            <el-button type="primary" @click="login">登 录</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="短信登录" name="second">
                    <el-form :model="loginVerCode" :rules="rules" ref="loginMobile" label-width="0" class="demo-ruleForm">
                        <el-form-item label="" prop="mobileno">
                            <el-input v-model.trim="loginVerCode.mobileno" prefix-icon="el-icon-mobile-phone"
                                      placeholder="请输入手机号" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="usercode" class="vm-smscode">
                            <el-input v-model.trim="loginVerCode.usercode" placeholder="请输入图形验证码" clearable></el-input>
                            <img :src="loginVerCode.codeImg" alt="" class="img pointer" @click="getCodeImg">
                        </el-form-item>
                        <el-form-item label="" prop="smscode" class="vm-smscode">
                            <el-input v-model.trim="loginVerCode.smscode" placeholder="请输入短信验证码" clearable></el-input>
                            <el-button type="primary" plain @click="sendCode" :disabled="timer.countdown">{{timer.countdown
                                ? timer.num + 's': '获取验证码'}}
                            </el-button>
                        </el-form-item>
                        <el-form-item label="" class="vm-btns">
                            <el-button type="primary" @click="loginMobile">登 录</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
            <el-tabs v-model="active.name" v-if="active.type=='forget'" class="register">
                <el-tab-pane label="找回密码" name="first">
                    <el-form :model="forget" :rules="rules" ref="forget" label-width="0" class="demo-ruleForm">
                        <el-form-item label="" prop="mobileno">
                            <el-input v-model.trim="forget.mobileno" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号"
                                      clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="usercode" class="vm-smscode">
                            <el-input v-model.trim="forget.usercode" placeholder="请输入图形验证码" clearable></el-input>
                            <img :src="forget.codeImg" alt="" class="img pointer" @click="getCodeImg">
                        </el-form-item>
                        <el-form-item label="" prop="usercode" class="vm-smscode" style="display: none;">
                            <el-input v-model.trim="forget.usercode" placeholder="请输入图形验证码" clearable></el-input>
                            <img :src="forget.codeImg" alt="" class="img pointer" @click="getCodeImg">
                        </el-form-item>
                        <el-form-item label="" prop="smscode" class="vm-smscode">
                            <el-input v-model.trim="forget.smscode" placeholder="请输入短信验证码" clearable></el-input>
                            <el-button type="primary" plain @click="sendCode" :disabled="timer.countdown">{{timer.countdown
                                ? timer.num + 's': '获取验证码'}}
                            </el-button>
                        </el-form-item>
                        <el-form-item label="" prop="password">
                            <el-input type="password" v-model.trim="forget.password" prefix-icon="el-icon-lock"
                                      placeholder="请输入新密码" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="password2">
                            <el-input type="password" v-model.trim="forget.password2" prefix-icon="el-icon-lock"
                                      placeholder="再次输入新密码确认" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" class="vm-btns">
                            <el-button type="primary" @click="handleForget">完 成</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
            <el-tabs v-model="active.name" v-if="active.type=='register'" class="register">
                <el-tab-pane label="账号注册" name="first">
                    <el-form :model="register" :rules="rules" ref="register" label-width="0" class="demo-ruleForm">
                        <el-form-item label="" prop="mobileno">
                            <el-input v-model.trim="register.mobileno" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号"
                                      clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="password">
                            <el-input type="password" v-model.trim="register.password" prefix-icon="el-icon-lock"
                                      placeholder="请输入密码" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="password" style="display: none;">
                            <el-input type="password" v-model.trim="register.password" prefix-icon="el-icon-lock"
                                      placeholder="请输入密码" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="usercode" class="vm-smscode">
                            <el-input v-model.trim="register.usercode" placeholder="请输入图形验证码" clearable></el-input>
                            <img :src="register.codeImg" alt="" class="img pointer" @click="getCodeImg">
                        </el-form-item>
                        <el-form-item label="" prop="smscode" class="vm-smscode">
                            <el-input v-model.trim="register.smscode" placeholder="请输入短信验证码" clearable></el-input>
                            <el-button type="primary" plain @click="sendCode" :disabled="timer.countdown">{{timer.countdown
                                ? timer.num + 's': '获取验证码'}}
                            </el-button>
                        </el-form-item>
                        <el-form-item label="" class="vm-btns">
                            <el-button type="primary" @click="handleRegister" :disabled="!registerCheck">注 册</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
            <div class="flex-between vm-oper" v-if="active.type=='login'">
                <div class="left tc-grey flex-start">
                    <div v-if="active.name=='first'">
                        <el-checkbox v-model="checked">记住密码</el-checkbox>
                        <span style="margin: 0 5px;">|</span>
                    </div>
                    <span class="hover pointer" @click="goToForgetPass">忘记密码？</span>
                </div>
                <span class="tc-blue pointer" @click="goToRegister">去注册 ></span>
            </div>
            <div class="flex-between vm-oper" v-if="active.type=='forget'">
                <div class="left tc-grey flex-start">
                    <span class="hover pointer" @click="goToLogin">返回登录</span>
                </div>
                <span class="tc-blue pointer" @click="goToRegister">去注册 ></span>
            </div>
            <div class="flex-between vm-oper" v-if="active.type=='register'">
                <div class="left tc-grey flex-start">
                    <el-checkbox v-model="registerCheck">我同意
                        <a href="http://www.capwhale.com/index/userTerms.html" class="tc-blue" target="_blank">《用户使用协议》</a>
                        和
                        <a href="https://www.capwhale.com/index/privacy.html" class="tc-blue" target="_blank">《隐私政策》</a>
                    </el-checkbox>
                </div>
                <span class="tc-blue pointer" @click="goToLogin">去登录 ></span>
            </div>
            <div class="vm-box flex-center" v-if="active.type=='login'">
                <div class="vm-line"></div>
                <div class="vm-we-chat flex-center">
                    <img :src="require('@/common/images/header/weChat.png')" alt="" class="vm-icon pointer" @click="weChatLogin">
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {getSmsCode,loginByMobile,loginByPassword,userRegister,resetPass,getThdLoginInfo,getCustomerInfo,creatImgCode} from 'api/api'
import {setCookie} from 'common/js/tools'
import {mapActions, mapGetters} from 'vuex'
// import {getQueryParams} from 'common/js/tools'
import $ from 'jquery'
export default {
name: 'LogAndReg',
data() {
  const querpassword = (rule, value, callback) => {
    let item = null;
    if (this.active.type == 'forget') {
      item = this.forget;
    } else if (this.active.type == 'register') {
      item = this.register;
    }
    if (value === '') {
      callback(new Error('请确认新密码'));
    } else if (value !== item.password) {
      callback(new Error('两次输入的密码不一致'));
    } else {
      callback();
    }
  }
  return {
    rules: {
      username: [
        {required: true, message: '用户名不能为空', trigger: 'blur'}
      ],
      password: [
        {required: true, message: '密码不能为空', trigger: 'blur'}
      ],
      password2: [
        {required: true, message: '密码不能为空', trigger: 'blur'},
        {validator: querpassword, trigger: 'blur'}
      ],
      mobileno: [
        {required: true, message: '手机号码不能为空', trigger: 'blur'},
        {pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/, message: '格式不正确', trigger: 'blur'}
      ],
      usercode: [
        {required: true, message: '图形码不能为空', trigger: 'blur'}
      ],
      smscode: [
        {required: true, message: '验证码不能为空', trigger: 'blur'}
      ]
    },
    visible: false,
    active: {
      type: 'login', // login 登录 register 注册 forget 找回密码
      name: 'first'
    },
    loginPass: { // 账号密码登录
      username: '', // 账号
      password: '' // 密码
    },
    loginVerCode: {
      codeImg: '',
      mobileno: '',
      smscode: '',
      usercode: '',
      codeEncryption: '',
      smstype: '1' // 1:验证码 2：找回密码 3：动态密码登录
    },
    forget: {
      codeImg: '',
      mobileno: '',
      usercode: '',
      smscode: '',
      password: '', // 密码
      password2: '', // 密码
      codeEncryption: '',
      smstype: '2' // 1:验证码 2：找回密码 3：动态密码登录
    },
    register: {
      codeImg: '',
      mobileno: '',
      usercode: '',
      smscode: '',
      password: '', // 密码
      codeEncryption: '',
      smstype: '2' // 1:验证码 2：找回密码 3：动态密码登录
    },
    loginRules: {},
    checked: false,
    timer: {
      countdown: false,
      num: 90
    },
    registerCheck: false
  }
},
created() {
  console.log(this.active)
  // let token = getQueryParams().token || '';
  // if (token) {
  //   this._setCookie('token', token);
  //   let user = $.extend({}, this.user)
  //   user.loginToken = token
  //   sessionStorage.setItem('user', JSON.stringify(user));
  //   window.location.replace(window.location.protocol+'//'+window.location.host+window.location.path);
  // } else {
  //   if (this._getCookie('token')) {
  //     if (!this.user.innerid) {
  //       let user = $.extend({}, this.user)
  //       user.loginToken = this._getCookie('token')
  //       this.setUser(user)
  //       this.getUserInfo()
  //     }
  //   } else {
  //     let user = $.extend({}, this.user)
  //     user.loginToken = ''
  //     user.innerid = ''
  //     this.setUser(user)
  //     sessionStorage.removeItem('user');
  //   }
  // }
},
methods: {
  handleLoginTab() {
    if (this.active.type == 'login' && this.active.name == 'first') {
      this.loginVerCode = {
        codeImg: this.loginVerCode.codeImg,
        mobileno: '',
        smscode: '',
        usercode: '',
        codeEncryption: this.loginVerCode.codeEncryption,
        smstype: '1'
      };
      this.$refs.loginPass.resetFields();
    } else if (this.active.type == 'login' && this.active.name == 'second') {
      this.loginPass = {
        username: '',
        password: ''
      };
      this.$refs.loginMobile.resetFields();
      if (!this.loginVerCode.codeImg) {
        this.getCodeImg();
      }
    }
  },
  closeSerDialog() {
    this.active.type = 'login';
    this.active.name = 'first';
    this.setLoginPop(false);
  },
  // 根据用户输入的用户名 匹配用户名列表
  getLocalPsw() {
    let storage = window.localStorage
    if (storage.getItem('user')) {
      let user = JSON.parse(storage.getItem('user'))
      this.loginPass.password = user.password
      if (user.username === this.loginPass.username) {
        this.loginPass.password = user.password
        this.checked = true
      } else {
        this.loginPass.password = ''
      }
    }
  },
  // 倒计时
  countdown() {
    let _this = this;
    let timer = setInterval(() => {
      _this.timer.num--;
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      _this.timer.countdown = false;
    }, 60000);
  },
  // 跳转登录
  goToLogin() {
    this.loginPass = {
      username: '',
      password: ''
    };
    this.loginVerCode = {
      codeImg: this.loginVerCode.codeImg,
      mobileno: '',
      smscode: '',
      usercode: '',
      codeEncryption: this.loginVerCode.codeEncryption,
      smstype: '1'
    };
    if (this.active.type == 'forget') {
      this.$refs.forget.resetFields();
    } else {
      this.$refs.register.clearValidate();
    }
    this.active.type = 'login';
    this.active.name = 'first';
  },
  // 跳转找回密码
  goToForgetPass() {
    this.forget = {
      codeImg: this.forget.codeImg,
      mobileno: '',
      usercode: '',
      smscode: '',
      password: '',
      password2: '',
      codeEncryption: this.forget.codeEncryption,
      smstype: '2'
    };
    if (this.active.type == 'login' && this.active.name == 'first') {
      this.$refs.loginPass.resetFields();
    } else if (this.active.type == 'login' && this.active.name == 'second') {
      this.$refs.loginMobile.resetFields();
    } else {
      this.$refs.register.resetFields();
    }
    if (!this.forget.codeImg) this.getCodeImg();
    this.active.type = 'forget';
    this.active.name = 'first';
  },
  // 跳转注册
  goToRegister() {
    this.register = {
      codeImg: this.register.codeImg,
      mobileno: '',
      usercode: '',
      smscode: '',
      password: '',
      codeEncryption: this.register.codeEncryption,
      smstype: '2'
    };
    if (this.active.type == 'login' && this.active.name == 'first') {
      this.$refs.loginPass.resetFields();
    } else if (this.active.type == 'login' && this.active.name == 'second') {
      this.$refs.loginMobile.resetFields();
    } else {
      this.$refs.forget.resetFields();
    }
    if (!this.register.codeImg) this.getCodeImg();
    this.active.type = 'register';
    this.active.name = 'first';
  },
  getCodeImg() {
    this.setLoading(true)
    creatImgCode({
      data: {},
      success: data => {
        if (this.active.type == 'forget') {
          this.forget.codeEncryption = data.result.codeEncryption;
          this.forget.codeImg = data.result.base64;
        } else if (this.active.type == 'register') {
          this.register.codeEncryption = data.result.codeEncryption;
          this.register.codeImg = data.result.base64;
        } else {
          this.loginVerCode.codeEncryption = data.result.codeEncryption;
          this.loginVerCode.codeImg = data.result.base64;
        }
        this.setLoading(false)
      },
      error: data => {
        this.$message.error(data.msg)
        this.setLoading(false)
      }
    })
  },
  // 发送手机验证码
  sendCode() {
    let item = null;
    if (this.active.type == 'forget') {
      if (!this.forget.mobileno || !this.forget.usercode) {
        this.$refs.forget.validateField('mobileno');
        this.$refs.forget.validateField('usercode');
        return false;
      }
      item = this.forget;
    } else if (this.active.type == 'register') {
      if (!this.register.mobileno || !this.register.usercode) {
        this.$refs.register.validateField('mobileno');
        this.$refs.register.validateField('usercode');
        return false;
      }
      item = this.register;
    } else {
      if (!this.loginVerCode.mobileno || !this.loginVerCode.usercode) {
        this.$refs.loginMobile.validateField('mobileno');
        this.$refs.loginMobile.validateField('usercode');
        return false;
      }
      item = this.loginVerCode;
    }
    this.timer.countdown = true;
    this.setLoading(true)
    getSmsCode({
      data: item,
      success: data => {
        if (data.success) {
          this.countdown()
          this.$message.success('验证码获取成功，请注意查收手机短信')
        }
        this.setLoading(false)
      },
      error: data => {
        this.timer.countdown = false
        this.setLoading(false)
        this.$message.error(data.msg)
      }
    })
  },
  handleForget() {
    this.$refs.forget.validate(valid => {
      if (valid) {
        this.setLoading(true)
        resetPass({
          data: this.forget,
          success: () => {
            this.$refs.forget.resetFields();
            this.$message.success('重置成功，请登录');
            this.loginPass.username = this.forget.mobileno;
            this.loginPass.password = '';
            this.active.type = 'login';
            this.active.name = 'first';
            this.setLoading(false)
          },
          error: data => {
            this.$message.error(data.msg)
            this.setLoading(false)
          }
        })
      }
    })
  },
  handleRegister() {
    this.$refs.register.validate(valid => {
      if (valid) {
        this.setLoading(true)
        console.log(this.register)
        userRegister({
          data: this.register,
          success: data => {
            if (data.success) {
              this.$refs.register.resetFields();
              this.loginPass.username = this.register.mobileno;
              this.loginPass.password = '';
              this.active.type = 'login';
              this.active.name = 'first';
            }
            this.setLoading(false)
          },
          error: data => {
            this.$message.error(data.msg)
            this.setLoading(false)
          }
        })
      }
    })
  },
  // 根据返回的token获取用户信息
  getUserInfo() {
    getCustomerInfo({
      data: {},
      success: data => {
        if (data.data) {
          this._saveLoginTicket2(data.data)
        }
      },
      error: data => {
        this.$message.error(data.msg)
      }
    })
  },
  // 微信登录
  weChatLogin() {
    getThdLoginInfo({
      data: {
        reurl: window.location.href,
        thdtype: 1
      },
      success: data => {
        // console.log(data.data)
        window.location.replace(data.data.url)
      },
      error: data => {
        this.$message.error(data.msg)
      }
    })
  },
  // 账号密码登录
  login() {
    this.$refs.loginPass.validate(valid => {
      if (valid) {
        this.setLoading(true)
        loginByPassword({
          data: this.loginPass,
          success: data => {
            this._rememberPsw();
            this._saveLoginTicket(data.data.object);
            this.$refs.loginPass.resetFields();
            this.setLoginPop(false);
            this.setLoading(false)
          },
          error: data => {
            this.$message.error(data.msg)
            this.setLoading(false)
          }
        })
      }
    })
  },
  // 手机号码短信登录
  loginMobile() {
    this.$refs.loginMobile.validate(valid => {
      if (valid) {
        this.setLoading(true)
        let loginVerCode = $.extend(true, {}, this.loginVerCode)
        delete loginVerCode.codeImg
        loginByMobile({
          data: loginVerCode,
          success: data => {
            this._saveLoginTicket(data.data.object);
            this.$refs.loginMobile.resetFields();
            this.setLoginPop(false);
            this.setLoading(false)
          },
          error: data => {
            this.$message.error(data.msg)
            this.setLoading(true)
            this.setLoading(false)
          }
        })
      } else {
        return false
      }
    })
  },
  _rememberPsw() {
    let storage = window.localStorage;
    if (this.checked) {
      storage.setItem('user', JSON.stringify({
        'username': this.loginPass.username,
        'password': this.loginPass.password
      }));
    } else {
      storage.removeItem('user');
    }
  },
  _saveLoginTicket(data) {
    let user = {
      innerid: data.innerid,
      loginToken: data.loginToken,
      loginname: data.loginname,
      logourl: data.logourl,
      mobile: data.mobile,
      name: data.name,
      nickname: data.nickname,
      isLogin: true,
      zjmemtype: data.zjmemtype
    }
    window.sessionStorage.setItem('user', JSON.stringify(user))
    this.setUser(user)
    this._setCookie('token', user.loginToken);
  },
  // 微信登录保存登录凭据
  _saveLoginTicket2(data) {
    setCookie('token', data.loginToken)
    let user = {
      innerid: data.innerid,
      loginToken: data.loginToken,
      loginname: data.loginname,
      logourl: data.logourl,
      mobile: data.mobile,
      name: data.name,
      nickname: data.nickname,
      isLogin: true
    }
    window.sessionStorage.setItem('user', JSON.stringify(user))
    this.setUser(user)
    this._setCookie('token', user.loginToken);
  },
  _getCookie(key) {
    let name = key + "=";
    let ca = document.cookie.split(';');
    for(let i=0; i<ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1);
      if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
    }
    return '';
  },
  _setCookie(key, value, expiredays) {
    let exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie = key + '=' + value
      + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
      + ';path=/'
      + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
  },
  _delCookie(key) {
    this._setCookie(key, "", -1);
  },
  ...mapActions([
    'setLoading',
    'setLoginPop',
    'setUser',
    'setClientType'
  ])
},
filters: {},
watch: {
  loginPop: {
    handler(newV) {
      if (newV) {
        this.$nextTick(() => {
          this.visible = true
        })
      } else {
        this.visible = false
      }
    },
    immediate: true,
    deep: true
  }
},
computed: {
  ...mapGetters(
    ['loginPop', 'user', 'ClientType']
  )
},
components: {}
}
</script>

<style lang="scss" type="text/scss">
.login{
    .tc-black{color: #333 !important;}
    .tc-gray{color: #666 !important;}
    .tc-grey{color: #999 !important;}
    .tc-blue{color:  #409EFF !important;}
    .pointer{cursor: pointer;}
    .hover:hover{color: #409EFF !important;}

    .flex-start{display: flex;align-items: center;}
    .flex-between{display: flex;align-items: center;justify-content: space-between;}
    .flex-center{display: flex;align-items: center;justify-content: center;}
    .vm-serve-dialog {
        // background: url('../../../common/images/common/login_bg.jpg') no-repeat;
        // background-size: 100% 100%;
    }
    .vm-serve-dialog .el-dialog__header{
        height: 10px;
        padding: 0 20px;
    }
    .vm-serve-dialog .el-tabs__item{
        width: 180px;
        text-align: center;
        font-size: 18px;
        height: 50px;
    }
    .vm-serve-dialog .el-tabs__content{
        padding: 12px 0 16px 0;
    }
    .vm-serve-dialog .el-dialog__body{
        padding: 20px 40px 30px 40px;
    }
    .vm-serve-dialog .el-button{
        width: 100%;
        font-size: 16px;
        height: 40px;
    }
    .vm-serve-dialog .vm-btns.el-form-item{
        margin-bottom: 0;
    }
    .vm-serve-dialog .el-checkbox{
        color: #999;
        margin-bottom: 0;
    }
    .vm-serve-dialog .vm-oper{
        font-size: 14px;
    }
    .vm-serve-dialog .vm-box{
        margin-top: 25px;
        height: 48px;
        position: relative;
    }
    .vm-serve-dialog .vm-box .vm-line{
        height: 1px;
        background: #E5E5E5;
        width: 100%;
        border-width: 0;
    }
    .vm-serve-dialog .vm-box .vm-we-chat{
        position: absolute;
        width: 54px;
        height: 54px;
        border-radius: 50%;
        top: 50%;
        margin-top: -27px;
        background: #fff;
    }
    .vm-serve-dialog .vm-box .vm-we-chat .vm-icon{
        width: 48px;
        height: 48px;
    }
    .vm-serve-dialog .vm-smscode .el-form-item__content{
        display: flex;
        align-items: center;
    }
    .vm-serve-dialog .vm-smscode .el-button, .vm-serve-dialog .vm-smscode .img{
        width: 118px;
        min-width: 118px;
        margin-left: 20px;
        font-size: 14px;
    }

    .vm-serve-dialog .el-input, .vm-serve-dialog input{
        /* height: 46px;
        line-height: 46px; */
        font-weight: 200;
    }
    .vm-serve-dialog .el-input__prefix .el-input__icon{
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 5px;
    }
    .vm-serve-dialog .el-input--prefix input{
        padding-left: 46px;
    }
    .vm-serve-dialog .el-tabs__item{
        font-weight: 400;
        color: #999;
    }
    .vm-serve-dialog .el-tabs__item.is-active{
        color: #666;
    }
    .vm-serve-dialog .register .el-tabs__active-bar,.vm-serve-dialog .register .el-tabs__nav-wrap:after{
        display: none
    }
    .vm-serve-dialog .register .el-tabs__item{
        justify-content: flex-start;
        text-align: left;
    }
    .vm-serve-dialog .register .el-tabs__header{
        margin-bottom: 5px;
    }
    .vm-serve-dialog .register .el-tabs__content{
        text-align: left;
        color: #666 !important;
        padding-top: 0;
    }
}
</style>